import React from 'react';
import { LocationTypes } from './locationTypes';
import { VariantContext } from './hooks/VariantContext';
import { Row } from '../../../../components/row/Row';
import { convertCMSHrsToFormattedHrs } from './helpers/convertHrsToText';

// Get formatted hrs of a location
export const getFormattedHrs = (location: LocationTypes.TLocation) => {
  return {
    officeHrs: convertCMSHrsToFormattedHrs(location.hours.officeHrs),
    gateHrs: convertCMSHrsToFormattedHrs(location.hours.gateHrs),
  };
};

export const LocationMap = (LocationMapDetails: LocationTypes.ILocationMap) => {
  const {
    locations,
    width,
    fullWidth,
    variant = 'cover-image',
    className = '',
  } = LocationMapDetails;

  const iFrameComponent = () => {
    // Temporarily picking only the first location. Will need to change this to support multiple locations.
    const location = locations[0];
    return location.iFrameUrl ? (
      <iframe
        allowFullScreen
        height="100%"
        src={location.iFrameUrl}
        width="100%"
        style={{
          border: 0,
        }}
      ></iframe>
    ) : (
      <></>
    );
  };
  return (
    <div className={`locationMap ${className} is-width-100`}>
      <div
        className="map"
        style={{
          width: fullWidth || variant === 'cover-image' ? '100%' : width,
        }}
        id="map"
      >
        <VariantContext.Provider value={variant}>
          <div className="google-map">
            <Row className="is-width-100 is-full-height mx-0">
              {iFrameComponent()}
            </Row>
          </div>
        </VariantContext.Provider>
      </div>
    </div>
  );
};
